import { render, staticRenderFns } from "./SelectItem.vue?vue&type=template&id=0630ef43&scoped=true&"
import script from "./SelectItem.vue?vue&type=script&lang=ts&"
export * from "./SelectItem.vue?vue&type=script&lang=ts&"
import style0 from "./SelectItem.vue?vue&type=style&index=0&id=0630ef43&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0630ef43",
  null
  
)

export default component.exports